<template>
  <el-dialog 
    width="540px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px" size="medium">   
      <el-col :span="24">     
        <el-form-item label="标题">          
          <el-input v-model="form.title"></el-input>        
        </el-form-item>      
      </el-col>
      <el-col :span="12">
        <el-form-item label="产品" >
          <el-input v-model="productName" readonly placeholder="选择产品">         
            <el-button slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
          </el-input>   
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="数量">
          <el-input v-model="form.count" >                   
            <template slot="append">次</template>
          </el-input>
        </el-form-item>
      </el-col>      
      <el-col :span="12">
        <el-form-item label="售价">
          <el-input v-model="form.price"  >                   
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-col>      
      <el-col :span="12">
        <el-form-item label="原价">
          <el-input v-model="form.originalPrice" >            
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-col>     
      <el-col :span="12">
        <el-form-item label="抽成">
          <el-input v-model="form.commission"  label="抽成">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-col>  
      <el-col :span="12">
        <el-form-item label="单人限购">
          <el-input v-model="form.limitCount"  label="抽成">
            <template slot="append">份</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="有效期">
          <el-input v-model="form.validityDays" label="有效期">
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
      </el-col>  
      <el-col :span="12">
        <el-form-item label="上架">
          <el-switch
              v-model="form.putOnShelves">
            </el-switch>
        </el-form-item>
      </el-col> 

      <el-col :span="24">
        <el-form-item label="分享描述">
          <el-input type="textarea" v-model="form.shareDescription"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">保 存</el-button>
    </div>    
    <GetProduct v-bind:dialogProduct="dialogProduct" @UpdateProduct="UpdateProduct"></GetProduct>
  </el-dialog> 
</template>

<script  type='text/ecmascript-6'>
import GetProduct from '@/components/GetProduct'
export default {
  props:{
    dialog:{}
  },
  data (){
    return {
      form : {},
      productName:'',
      dialogProduct:{
        isShow:false
      },
    }
  },  
  components:{    
    GetProduct  
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){      
      console.log("open:"+this.dialog.id)
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/MeasuredService/Get',         
        data:{
          id: that.dialog.id
        }
      }).then(function (resp) {
        debugger
        if(resp.data.errorCode==0){
          that.form = resp.data.data
          that.productName = resp.data.productName
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },     
    selectStoreHandle:function(){
      this.dialogProduct.isShow = true
    },
    UpdateProduct:function(id,name){
      this.form.productId = id 
      this.productName = name 
      this.dialogProduct.isShow = false
    },
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/MeasuredService/Save',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialog.isShow = false
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    }
  },
  created(){
  
  },
}
</script>